// extracted by mini-css-extract-plugin
export default {"scrollable-result-block":"UdoAR"};